import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLogInComponent } from './views/auth/main-log-in/main-log-in.component';
import { RecoverPasswordComponent } from './views/auth/recover-password/recover-password.component';
import { ResetPasswordComponent } from './views/auth/recover-password/reset-password/reset-password.component';
import { AuthGuard } from './views/auth/shared/auth.guard';
import { AuthService } from './views/auth/shared/auth.service';
import { RoleGuard } from './views/auth/shared/role.guard';
import { HomeComponent } from './views/home/home.component';
import { FormEventComponent } from './views/registration/events-forms/form-event/form-event.component';
import { MeetingEventComponent } from './views/registration/events-forms/meeting-event/meeting-event.component';
import { BriefingResponseComponent } from './views/registration/briefings/form-definitions/briefing-forms/briefing-response.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    children: [
      {
        path: '',
        redirectTo: 'home-cards',
        pathMatch: 'full'
      },
      {
        path: 'home-cards',
        loadChildren: () =>
          import('./views/home-cards/home-cards.module').then(
            (m) => m.HomeCardsModule
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'contacts',
        loadChildren: () =>
          import('./views/contacts/contacts.module').then(
            (m) => m.ContactsModule
          ),
      },
      {
        path: 'partners',
        loadChildren: () =>
          import('./views/registration/partners/partners.module').then(
            (m) => m.PartnersModule
          ),
      },
      {
        path: 'partner-dashboard',
        loadChildren: () =>
          import('./views/registration/partner-dashboard/partner-dashboard.module').then(
            (m) => m.PartnerDashboardModule
          ),
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./views/registration/customers/customers.module').then(
            (m) => m.CustomersModule
          ),
      },
      {
        path: 'accounts-receivable',
        loadChildren: () =>
          import('./views/registration/accounts-receivable/accounts-receivable.module').then(
            (m) => m.AccountsReceivableModule
          ),
      },
      {
        path: 'my-account',
        loadChildren: () =>
          import('./views/registration/charges/my-account-index/my-account-index.module').then(
            (m) => m.MyAccountIndexModule
          ),
      }, 
      {
        path: 'charges',
        loadChildren: () =>
          import('./views/registration/charges/charges.module').then(
            (m) => m.ChargesModule
          ),
      },
      {
        path: 'process-charges',
        loadChildren: () =>
          import('./views/registration/charges/components/process-charges/process-charges.module').then(
            (m) => m.ProcessChargesModule
          ),
      },
      {
        path: 'contracts',
        loadChildren: () =>
          import('./views/registration/contracts/contracts.module').then(
            (m) => m.ContractsModule
          ),
      },
      {
        path: 'accounts-payable',
        loadChildren: () =>
          import('./views/registration/accounts-payable/accounts-payable.module').then(
            (m) => m.AccountsPayableModule
          ),
      },
      {
        path: 'account-types',
        loadChildren: () =>
          import('./views/registration/account-types/account-types.module').then(
            (m) => m.AccountTypesModule
          ),
      },
      {
        path: 'account-movimentations',
        loadChildren: () =>
          import('./views/registration/account-movimentations/account-movimentations.module').then(
            (m) => m.AccountMovimentationsModule
          ),
      },
      {
        path: 'pass-on',
        loadChildren: () =>
          import('./views/registration/pass-on/pass-on.module').then(
            (m) => m.PassOnModule
          ),
      },
      {
        path: 'plans',
        loadChildren: () =>
          import('./views/registration/plans/plans.module').then(
            (m) => m.PlansModule
          ),
      },
      {
        path: 'systems',
        loadChildren: () =>
          import('./views/registration/systems/systems.module').then(
            (m) => m.SystemsModule
          ),
      },
      {
        path: 'systems-externals',
        loadChildren: () =>
          import('./views/registration/systems-external/systems-externals.module').then(
            (m) => m.SystemsExternalsModule
          ),
      },
      {
        path: 'system-modules',
        loadChildren: () =>
          import('./views/registration/system-modules/system-modules.module').then(
            (m) => m.SystemModulesModule
          ),
      },
      {
        path: 'system-action-params',
        loadChildren: () =>
          import(
            './views/registration/system-action-params/system-action-params.module'
          ).then((m) => m.SystemActionParamsModule),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./views/registration/users/crud.module').then(
            (m) => m.UserModule
          ),
      },
      {
        path: 'user-groups',
        loadChildren: () =>
          import('./views/registration/user-groups/user-groups.module').then(
            (m) => m.UserGroupsModule
          ),
      },
      {
        path: 'permission-groups',
        loadChildren: () =>
          import('./views/registration/permission-groups/permission-groups.module').then(
            (m) => m.PermissionGroupsModule
          ),
      },
      {
        path: 'payment-methods',
        loadChildren: () =>
          import('./views/registration/payment-methods/payment-methods.module').then(
            (m) => m.PaymentMethodsModule
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./views/registration/products/products.module').then(
            (m) => m.ProductsModule
          ),
      },
      {
        path: 'downloads',
        loadChildren: () =>
          import('./views/registration/downloads/downloads.module').then(
            (m) => m.DownloadsModule
          ),
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./views/registration/events-forms/events.module').then(
            (m) => m.EventsModule
          ),
      },
      {
        path: 'marketings',
        loadChildren: () =>
          import('./views/registration/marketings/marketings.module').then(
            (m) => m.MarketingsModule
          ),
      },
      {
        path: 'trainings',
        loadChildren: () =>
          import('./views/registration/trainings/trainings.module').then(
            (m) => m.TrainingsModule
          ),
      },
      {
        path: 'faq',
        loadChildren: () =>
          import('./views/registration/faq-events/faq.module').then(
            (m) => m.FaqModule
          ),
      },
      {
        path: 'briefing',
        loadChildren: () =>
          import('./views/registration/briefings/briefings.module').then(
            (m) => m.BriefingsModule
          ),
      },
      {
        path: 'briefing/answers',
        loadChildren: () =>
          import('./views/registration/briefings/briefing-answers/briefing-answers.module').then(
            (m) => m.BriefingAnswersModule
          ),
      },
      {
        path: 'mapa',
        loadChildren: () =>
          import('./views/mapa/mapa.module').then((m) => m.MapaModule),
      },
      {
        path: 'service-orders',
        loadChildren: () =>
          import('./views/registration/service-orders/service-orders.module').then(
            (m) => m.ServiceOrdersModule
          ),
      },
      {
        path: 'service-invoices',
        loadChildren: () =>
          import('./views/registration/service-invoices/service-invoices.module').then(
            (m) => m.ServiceInvoicesModule
          ),
      },
      {
        path: 'sales',
        loadChildren: () =>
          import('./views/registration/sales/sales.module').then(
            (m) => m.SalesModule
          ),
      },
      {
        path: 'cashier',
        canActivate: [RoleGuard],
        data: { role: 'MENU_CASHIER' },
        loadChildren: () =>
          import('./views/registration/cashier/cashier.module').then(
            (m) => m.CashierModule
          ),
      },
      {
        path: 'budgets',
        loadChildren: () =>
          import('./views/registration/budgets/budgets.module').then(
            (m) => m.BudgetsModule
          ),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./views/registration/orders/orders.module').then(
            (m) => m.OrdersModule
          ),
      },
      {
        path: 'value-references',
        loadChildren: () =>
          import('./views/registration/value-reference/value-reference.module').then(
            (m) => m.ValueReferencesModule
          ),
      },
      {
        path: 'customer-acess',
        loadChildren: () =>
          import('./views/registration/customer-acess/customer-acess.module').then(
            (m) => m.CustomerAcessModule
          ),
      },
      {
        path: 'payroll-payments',
        loadChildren: () =>
          import('./views/registration/payroll-payments/payroll-payments.module').then(
            (m) => m.PayrollPaymentsModule
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./views/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: 'print-center',
        loadChildren: () =>
          import('./views/print-center/print-center.module').then(
            (m) => m.PrintCenterModule
          ),
      },
      {
        path: 'registration/global-config',
        loadChildren: () => import('./views/registration/shared/global-config/global-config.module').then(m => m.GlobalConfigModule),
      },
      {
        path: 'accounts-dashboard',
        loadChildren: () => import('./views/registration/accounts-dashboard/account-dashboard.module').then(m => m.AccountDashboardModule),
      },
      {
        path: 'dre-reports',
        loadChildren: () => import('./views/registration/dre-reports/dre-reports.module').then(m => m.DreReportsModule),
      },
      {
        path: 'financial-reports',
        loadChildren: () => import('./views/registration/financial-reports/financial-reports.module').then(m => m.FinancialReportsModule),
      },
      {
        path: 'charge-customer',
        loadChildren: () => import('./views/registration/charges/components/charge-customer/charge-customer.module').then(m => m.ChargeCustomerModule),
      },
      {
        path: 'merchants',
        loadChildren: () =>
          import('./views/registration/merchants/merchants.module').then(
            (m) => m.MerchantsModule
          ),
      },
      {
        path: 'schedule',
        loadChildren: () =>
          import('./views/registration/schedule/schedule.module').then(
            (m) => m.ScheduleModule
          ),
      },
    ],
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard]
  },
  {
    path: 'form-event/:id',
    component: FormEventComponent,
  },
  {
    path: 'meeting-event/:eventId/:meetingId',
    component: MeetingEventComponent,
  },
  {
    path: 'briefing/:id',
    component: BriefingResponseComponent,
  },
  {
    path: 'recuperar-senha',
    component: RecoverPasswordComponent,
  },
  {
    path: 'recuperar-senha/redefinir',
    component: ResetPasswordComponent,
  },
  {
    path: '',
    component: MainLogInComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      { path: 'login', component: MainLogInComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthService]
})
export class AppRoutingModule { }
